(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["_offer"] && !Shopify.designMode) return;
  try {
    // Self-contained: click an offer code to copy it, with a confirm animation.
  if (!customElements.get('offer-code')) {
    customElements.define(
      'offer-code',
      class OfferCode extends HTMLElement {
        connectedCallback() {
          this.button = this.querySelector('.offer-code__btn');
          if (this.button && !this.button.dataset.bound) {
            this.button.dataset.bound = '1';
            this.button.addEventListener('click', () => this.copy());
          }
        }

        async copy() {
          const code = (this.dataset.code || this.textContent || '').trim();
          if (!code) return;

          try {
            await navigator.clipboard.writeText(code);
          } catch (e) {
            // Fallback for older / insecure contexts
            const ta = document.createElement('textarea');
            ta.value = code;
            ta.setAttribute('readonly', '');
            ta.style.position = 'absolute';
            ta.style.left = '-9999px';
            document.body.appendChild(ta);
            ta.select();
            try { document.execCommand('copy'); } catch (err) {}
            ta.remove();
          }

          this.classList.add('is-copied');
          clearTimeout(this._resetTimer);
          this._resetTimer = setTimeout(() => this.classList.remove('is-copied'), 1800);
        }
      }
    );
  }
  } catch(e) { console.error(e); }
})();

})();
